import _ from "lodash";
import { useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useTransferOwnership = () => {
  const [message, setMessage] = useState("");
  const [waitConfirmTransfer, setWaitConfirmTransfer] = useState(false);
  const tokenAddress = localStorage.getItem("tokenContractAddress");

  const callTransferOwnership = async (
    signer: ethers.ContractRunner | null | undefined,
    address: string
  ) => {
    try {
      setWaitConfirmTransfer(true);

      const transfer = new ethers.Contract(
        tokenAddress || "",
        ERC20ABI.abi,
        signer
      );

      const tx = await transfer.transferOwnership(address);
      setWaitConfirmTransfer(false);
      return { err: "", tx: tx };
    } catch (err: any) {
      const errs = _.get(err, "error.message");
      const msgs = _.get("", errs);
      if (err.code === "ACTION_REJECTED") {
        setWaitConfirmTransfer(false);
        setMessage("User rejected transaction");
        return { err: "User rejected transaction", tx: "" };
      } else {
        if (msgs === undefined) {
          setWaitConfirmTransfer(false);
          setMessage(err.message.split("(")[0] || "");
          return { err: err.message.split("(")[0] || "", tx: "" };
        } else {
          setWaitConfirmTransfer(false);
          setMessage(msgs.msg);
          return { err: msgs.msg, tx: "" };
        }
      }
    }
  };

  return {
    onTransferOwnership: callTransferOwnership,
    waitConfirmTransfer: waitConfirmTransfer,
    messageError: message,
  };
};
